<div class="d-flex flex-column overflow-auto p-3 p-lg-5">

    <h3>{{ "legal-pp-title" | translate }}</h3>

    <p>
        <span>{{ "legal-pp-p-1" | translate }} </span>
        <span>{{ "legal-pp-p-2" | translate }}</span>
    </p>
    <p>{{ "legal-pp-p-3" | translate }}</p>
    <p>{{ "legal-pp-p-4" | translate }}</p>
    <p>{{ "legal-pp-p-5" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-1" | translate }}</h5>
    <p>{{ "legal-pp-p-6" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-2" | translate }}</h5>
    <p>{{ "legal-pp-p-7" | translate }}</p>
    בעניין מדיניות הפרטיות, וכן לתלונות על הטיפול במידע בא
    <p>{{ "legal-pp-p-8" | translate }}</p>
    <p>{{ "legal-pp-p-9" | translate }}</p>

    <p>{{ "legal-pp-p-10" | translate }}</p>
    <p>{{ "legal-pp-p-11" | translate }}</p>
    <p>{{ "legal-pp-p-12" | translate }}</p>

    <p>{{ "legal-tandc-hotjar-1" | translate }}</p>
    <p>{{ "legal-tandc-hotjar-2" | translate }}</p>
    <p>
        {{ "legal-tandc-hotjar-3" | translate }}
        <a style="color: var(--mat-sidenav-content-text-color)"
            href="https://www.hotjar.com/legal/policies/privacy">https://www.hotjar.com/legal/policies/privacy</a>
        {{ "legal-tandc-hotjar-4" | translate }}
        <a style="color: var(--mat-sidenav-content-text-color)"
            href="https://www.hotjar.com/legal/policies/privacy">https://www.hotjar.com/policies/do-not-track/</a>
    </p>

    <h5>{{ "legal-pp-sub-title-3" | translate }}</h5>
    <p>{{ "legal-pp-p-13" | translate }}</p>
    <ul>
        <li>
            <p>{{ "legal-pp-li-1-1" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-1-2" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-1-3" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-1-4" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-1-5" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-1-6" | translate }}</p>
        </li>
    </ul>

    <p>{{ "legal-pp-p-14" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-4" | translate }}</h5>
    <p>{{ "legal-pp-p-15" | translate }}</p>
    <ul>
        <li>
            <p>{{ "legal-pp-li-2-1" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-2-2" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-2-3" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-2-4" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-2-5" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-2-6" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-2-7" | translate }}</p>
        </li>
        <li>
            <p>{{ "legal-pp-li-2-8" | translate }}</p>
        </li>
    </ul>

    <p>{{ "legal-pp-p-16" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-5" | translate }}</h5>
    <p>{{ "legal-pp-p-17" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-6" | translate }}</h5>
    <p>{{ "legal-pp-p-18" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-7" | translate }}</h5>
    <p>{{ "legal-pp-p-19" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-8" | translate }}</h5>
    <p>{{ "legal-pp-p-20" | translate }}</p>

    <h5>{{ "legal-pp-sub-title-9" | translate }}</h5>
    <p>{{ "legal-pp-p-21" | translate }}</p>

    <span class="zx-hidden">-</span>
</div>

<div class="position-absolute bottom-0 w-100 d-flex justify-content-between align-items-center p-2 p-sm-3">
    <button mat-raised-button color="primary" type="submit"
        class="text-white rounded-pill zx-text-tiny zx-text-sm-small" (click)="navigateHome()">
        {{ "main-nav.new-order" | translate }}
    </button>
    <button mat-raised-button (click)="openWhatsApp()" class="rounded-pill zx-text-tiny zx-text-sm-small">
        <div class="w-100 h-100 d-flex align-items-center gap-2">
            <div class="whatsup-logo-container-small">
                <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small">
            </div>
            <span>
                {{'main-nav.contact-us' | translate}}
            </span>
        </div>
    </button>
</div>